import { forwardRef, type InputHTMLAttributes } from 'react'

type InputProps = InputHTMLAttributes<HTMLInputElement>

// Input — single source of truth for text/email/password styling. Keeps
// border-color and focus-ring consistent across forms.
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', ...rest }, ref) => (
    <input
      ref={ref}
      {...rest}
      className={`block w-full rounded-md border border-line-strong bg-surface px-3 py-2 text-sm text-cream placeholder:text-muted focus:border-glow-500 focus:outline-none focus:ring-1 focus:ring-glow-500 disabled:bg-surface-2 disabled:text-muted ${className}`}
    />
  ),
)
Input.displayName = 'Input'
